// import JSZip from 'jszip'
import { sgiZip } from './sgiCommon'
/**
 * 本地缓存方法集，封装window.localStorage
 * @namespace 本地缓存方法集
 * @alias tool.sgiStorage
 */
const sgiLocalStorage = {
	localMap: null,
	localSupported: undefined,

	/**
	 * 设置localStorage缓存
	 * @param {string} key 存储key
	 * @param {object} value 存储值
	 */
	set: function (key, value) {
		// var zip = new JSZip();
		// zip.file(key, value);
		// value = zip.generate({
		// 	'compression': 'DEFLATE',
		// 	type: "string"
		// });
		value = sgiZip.zip(key, value);
		if (this.localStorageSupported()) {
			return window.localStorage.setItem(key, value);
		} else {
			return this.localMap.add(key, value);
		}
	},

	/**
	 * 根据key值获取本地存储
	 * @param {string} key 存储key
	 * @returns {object} 存储值
	 */
	get: function (key) {
		var value;
		if (this.localStorageSupported()) {
			value = window.localStorage.getItem(key);
		} else {
			value = this.localMap.get(key);
		}
		if (value) {
			// var zip = new JSZip();
			// zip.load(value);
			// return zip.file(key).asText();
			// return value;
			return sgiZip.unzip(key, value);
		} else {
			return null;
		}
	},

	/**
	 * 清空本地存储
	 */
	clear: function () {
		if (this.localStorageSupported()) {
			window.localStorage.clear();
		} else {

			this.localMap.clear();
		}
	},

	/**
	 * 根据key删除本地存储
	 * @param {string} key 存储key
	 */
	remove: function (key) {
		if (this.localStorageSupported()) {
			window.localStorage.removeItem(key);
		}
		else {
			this.localMap.removeByKey(key);
		}
	},

	/**
	 * 根据前缀批量删除本地存储（谨慎使用，以免误删前缀相同存储）
	 * @param {string} prefix 存储key值前缀
	 */
	removeByPrefix: function (prefix) {
		if (!prefix) return;
		let preLength = prefix.length;
		if (this.localStorageSupported()) {
			let storage = window.localStorage;
			// let length = storage.length;//删除后，length会变
			for (let i = 0; i < storage.length; i++) {
				let key = storage.key(i);
				let pre = key.substr(0, preLength);
				if (pre === prefix) {
					storage.removeItem(key);
					i--;
				}
			}
		}
		else {
			this.localMap.removeByPrefix(prefix);
		}
	},

	/**
	 * 获取本地缓存长度
	 * @returns {number} 缓存长度
	 */
	length: function () {
		if (this.localStorageSupported()) {
			return window.localStorage.length;

		}
		else {
			return this.localMap.length;
		}
	},

	/**
	 * 根据索引序号获取存储key
	 * @param {number} index 索引序号
	 */
	key: function (index) {
		if (this.localStorageSupported()) {
			return window.localStorage.key(index);
		}
		else {
			return this.localMap.key(index);
		}
	},

	/**
	 * 判断window本地缓存支持情况
	 * @returns {boolean} window是否支持localstorage本地缓存
	 */
	localStorageSupported: function () {
		var testKey = 'test', storage = window.localStorage;
		if (this.localSupported === undefined) {
			try {
				storage.setItem(testKey, '1');
				storage.removeItem(testKey);
				this.localSupported = true;
			} catch (error) {
				this.localSupported = false;

			}
		}
		return this.localSupported;
	}

}

export { sgiLocalStorage };
export default sgiLocalStorage;


// WEBPACK FOOTER //
// ./~/rt-sd-common/sgiCommon/localStorage.js